// src/constants/homepageTexts.js
export const COUNT_TEXT = {
  today: "Today",
  thisWeek: "This Week",
  thisMonth: "This Month",
  beforeThreeMonths: "Before 3 Months",
};

// 개인정보 처리방침 텍스트
export const PRIVACY_POLICY = {
  title: "Privacy Policy",
  content: `개인정보처리방침
㈜비피앤솔루션(이하 "회사")는 개인정보보호법 등 관계 법령상의 개인정보보호 규정을 준수하고 있습니다. 회사는 WOB서비스를 제공하는 어플리케이션의 화면을 통하여 개인정보처리방침을 상시 고지하고 있으며, WOB 서비스를 이용하는 이용자 권익 보호에 최선을 다하고 있습니다. 본 개인정보처리방침은 회사가 제공하는 WOB 서비스(이하 “서비스”)에 적용됩니다.

서비스는 이용자의 동의를 기반으로 개인정보를 처리하고 있고, 이용자의 명시적인 동의 없이는 어떠한 정보도 수집 또는 이용하지 않으며, 국내 법령 및 기타 개인정보보호 관련 가이드라인을 준수하고 있습니다. 본 서비스의 개인정보 처리방침을 개정하는 경우 공지사항(또는 개별공지)을 통하여 공지할 것입니다.


제1조(개인정보 이용 목적 및 수집항목과 보유기간)

서비스는 정보 주체인 사용자가 인증서와 인증서에 담긴 신원 등에 대한 개인정보를 사용자 저장 데이터 형태로 본인 소유의 모바일 단말기에 직접 저장, 관리, 제출하는 자기주권형 신원증명 기반 서비스입니다.

① 서비스는 회원 가입 및 서비스 제공 등을 위하여 필요한 범위에서 최소한의 개인정보만을 수집합니다.

② 서비스 내 수집하는 개인정보 항목과 수집 이용하는 목적 및 보유 기간은 다음과 같습니다.
증명서	발급기관	수집항목	이용목적	보유기간
서비스 가입	이메일인증	비피앤솔루션	이름, 소속기관, 이메일	커피물류 시스템 내의 개인정보 인증 발급	사용자 단말에 저장하며, 비피앤솔루션은 개인정보를 저장하지 않음.

③ 서비스의 제공을 위하여 처리하는 개인정보는 이용 목적으로 명시한 범위 내에서만 처리됩니다.



제2조(개인정보의 제3자 위탁)

서비스는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
수탁업체명	㈜비피앤솔루션
위탁업무	메일 인증을 통한 본인 확인
위탁기간	위탁종료시 까지 



제3조(개인정보의 제3자 제공)

회사는 원칙적으로 정보 주체의 개인정보를 본 방침에 명시한 목적과 범위 내에서 처리하며, 다음의 경우를 제외하고는 본래의 목적 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다.

1. 정보주체로부터 별도의 동의를 받는 경우

2. 법률에 특별한 규정이 있거나 법령상의 의무를 준수하기 위하여 불가피한 경우

서비스 내 수집하는 개인정보 항목과 수집 이용하는 목적 및 보유 기간은 다음과 같습니다.

※ 증명서 종류에 따라 수집하는 내용이 상이할 수 있습니다.

증명서	발급기관	수집항목	이용목적	보유기간
WOB	발급 및 이용	㈜비피앤솔루션	이름, 소속기관, 이메일	WOB시스템 내 NFT소유권(제품정보) 이전을 위한 DID 개인인증	사용자 단말에 저장하며, 비피앤솔루션은 개인정보를 저장하지 않음.


3. 서비스 제공 시 앱에서 아래와 같은 접근권한을 요구합니다.
구분	접근항목	이용근거	접근목적
선택접근	휴대폰 메모리	정보주체의 동의	개인 인증을 위한 개인정보 제공 처리


제4조(개인정보의 수집 방법)

개인정보를 수집하는 경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 아래와 같은 방법을 통해 개인정보를 수집합니다.

① 서비스 가입이나 이용 과정에서 서비스 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우

② 제휴 서비스 및 단체 등으로부터 개인정보를 제공받은 경우

③ 서비스 이용자가 고객센터를 통한 상담 과정에서 메일, SNS 상담 등으로 이용자가 직접 제공하는 경우

④서비스 이용자가 이벤트, 행사 등에 참여하는 경우



제5조(동의의 거부권 등)

서비스 이용자는 개인정보 수집∙이용에 관한 동의를 거부할 권리가 있습니다. 다만, 각 증명서 별로 서비스의 제공을 위해 필요한 최소한의 개인정보 수집∙이용에 관한 동의를 거부하는 경우에는 서비스의 이용이 제한되는 등의 불이익이 있을 수 있습니다.



제6조(개인정보의 파기절차 및 방법)

개인정보는 수집 및 이용목적이 달성되면 별도의 동의 및 법령근거가 없는 경우 지체없이 파기합니다.

서면양식에 기재하거나, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하고 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

이 외에 법령에 따라 일정기간 보관해야 하는 개인정보 및 해당 법령은 아래 표와 같습니다.
보존항목	근거법령	보존기간
소비자의 불만 또는 분쟁처리에 관한 기록	전자상거래 등에서의 소비자 보호에 관한 법률	3년
컴퓨터통신 또는 인터넷의 로그 기록 (서비스 이용기록, 접속로그, 접속 IP정보 등)	통신비밀보호법	3개월

제7조(개인정보 자동 수집 장치의 설치, 운영 및 거부에 관한 사항)

쿠키는 서비스운영에 이용되는 서버가 이용자 장치에 보내는 아주 작은 텍스트로 이용자의 장치에 저장됩니다. 쿠키 정보는 이용자의 디바이스 식별용도로만 활용되며 개개인을 식별하지 않습니다.

① 쿠키의 사용 목적

회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는 쿠키를 사용합니다. 또한, 이용자의 접속 빈도 또는 이용 시간 등을 분석하여 이용자의 취향과 관심분야를 파악하여 타켓(Target) 마케팅 활용 및 서비스 개편 등의 척도로 활용하기 위한 목적으로 활용됩니다.

② 쿠키 수집 거부

이용자는 아래와 같이 옵션을 설정함으로써 쿠키 정보의 저장을 제한할 수 있습니다. 모바일 앱의 경우아래의 방법을 통해 맞춤형 광고 설정을 해제할 수 있습니다.

1. Android : 설정 > Google 설정 > 광고 > ‘광고 맞춤설정 선택 해제’ 활성화

2. IOS: 설정 > 개인정보보호> 광고 > ‘광고 추적 제한’ 활성화



제8조(개인정보보호를 위한 기술적/관리적 대책)

이용자의 개인정보를 안전하게 보호하기 위해 필요한 조치를 운영하고 있습니다.

① 기술적인 대책

1. 회원의 개인정보는 비밀번호에 의해 보호되며, 개인정보 데이터는 별도의 보안 기능을 통해 보호됩니다.

- 이용자의 중요 개인정보는 암호화되어 저장 및 관리되고 있습니다.

- 회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다.

② 관리적인 대책

1. 위와 같은 노력 이외에 회원 스스로 제삼자에게 비밀번호 등이 노출되지 않도록 주의하여야 합니다. 특히 비밀번호 등이 공공장소에 설치한 PC를 통해 유출되지 않도록 항상 유의하여야 합니다. 회원의 ID와 비밀번호는 반드시 본인만 사용하고 비밀번호를 자주 바꾸는 것이 좋습니다.

2. 회사는 회사 규정에 별도의 전산관리규정을 마련하여 다음과 같은 사항을 준수합니다.

- (개인정보 보호책임자의 지정 등 개인정보보호 조직의 구성, 운영에 관한 사항) 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.

- (개인정보취급자의 교육에 관한 사항) 개인정보를 취급하는 직원을 지정하고 담당자에 한정하는 방식으로 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.

- (개인정보처리시스템의 접속 기록 유지) 개인정보를 검색, 조회할 경우 접속 기록이 생성되어 보관됩니다. 이는 개인정보를 누가 언제 조회하였는지에 대한 내용을 기록하여 개인정보에 관한 문제 발생시 이를 해결하기 위한 자료로 사용합니다.

- (정기적인 확인 감독) 개인정보 취급 관련 안전성 확보를 위해 정기적으로 자체 감사를 실시하고 있습니다.

- (개인정보 출력 및 복사 시의 보호조치) 개인정보 취급 시 개인정보가 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.

- (기타 개인정보 보호를 위해 필요한 사항) 그 외 개인정보보호를 위해 법령에서 요구하는 기술적, 관리적, 물리적 조치를 다하고 있습니다.



제9조(개인정보관리책임자 및 상담, 신고)

회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 회사는 개인정보 보호책임자를 두고 있습니다.

회원의 개인정보와 관련한 문의사항은 아래의 개인정보 보호책임자 또는 개인정보 보호담당자에게 연락하시기 바랍니다.
구분	개인정보 보호 책임자	개인정보 보호 담당자
담당부서	정보보안팀	정보보안팀
성명	김용길	김승혁
전화	051-917-9133
이메일	bpns@bpnsolution.com

회원은 회사의 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을 개인정보 보호책임자 혹은 담당 부서로 신고할 수 있습니다. 회사는 이용자의 신고사항에 대한 답변을 신속히 할 것입니다.

기타 개인정보침해 신고나 상담이 필요한 경우에는 아래 기관에 문의하시기 바랍니다.


개인정보관리책임자 및 상담, 신고
경찰청 사이버 안전국	홈페이지	http://cyverbureau.police.go.kr

	전화	(국번없이)182
대검찰청 사이버수사과	홈페이지	http://www.spo.go.kr

	전화	(국번없이) 1301
개인정보 분쟁조정위원회(개인정보보호위원회)	홈페이지	http://www.kopico.go.kr

	전화	1833-6972


제10조(고지의무)

법령.정책 또는 보안기술의 변경에 따라 내용의 추가.삭제 및 수정이 있을 시에는 변경사항 시행일의 7일전부터 서비스의 공지사항을 통하여 고지합니다. 단, 회원에게 불리한 내용이 포함된 경우, 변경사항 시행일의 30일전부터 고지합니다.


시행일자: 2024년  00월 00일


`,
};

// 내부관리 규정 텍스트
export const INTERNAL_REGULATIONS = {
  title: "서비스이용약관",
  content: `시행일 2024. 00. 00. 

제 1 장 총칙


제1조 (목적) 본 약관은 ㈜비피앤솔루션(서비스제공업체)에서 제공하는 WOB앱 서비스(이하 “서비스”라 합니다)를 이용자가 이 용함에 있어 서비스업체와 이용자 간의 권리, 의무 및 책임과 기타 필요한 사항을 규정함을 목적으로 합니다.


제2조 (용어의 정의) 본 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다. 

이용자 : 본 약관에 동의하고 본 약관 제5조에 따라 가입하여 서비스를 이용하는 자를 의미합니다.
신원증명 서비스 : 서비스제공업체에서 제공하는 WOB앱 내에서 개인인증 및 NFT소유권 이전, 커피제품생산 관리를 목적으로 스마트폰에 탑재된 블록체인 기반의 분산 신원증명(DID : Decentralized Identifier) 기술을 활용한 공개키기반구조 (PKI : Public Key Infrastructure)를 통해 사용자 본인에 대한 증명을 제공하는 모바일 신원증명서비스를 의미합니다.
서비스 : 제2호의 서비스를 위해 제공하는 블록체인 기반 커피물류 관리 서비스를 의미합니다. 
이용계약 : 서비스 이용과 관련하여 서비스를 제공하는 서비스업체와 이용자 간에 체결되는 계약을 의미합니다. 

제3조 (약관의 적용 범위 및 효력 등) ① 본 약관은 서비스를 이용하는 모든 이용자에 대하여 그 효력을 발생합니다. 

② 본 약관의 내용을 앱 초기화면에 게시하거나 기타의 방법으로 이용자에게 공지하며, 이 용자가 본 약관 제5조의 절차에 따라 가입 신청을 하고 서비스제공업체가 이에 동의함으로써 본 약관의 효 력이 발생합니다. 

③ 서비스제공업체는 필요하다고 인정되는 경우 본 약관을 개정할 수 있으며, 약관을 개정할 경우 그적용 일자, 내용, 개정 사유 등을 명시하여 현행 약관과 함께 적용일자 7일 전부터 제2항과 같은 방법으로 공 시합니다. 다만, 이용자의 권리 또는 의무에 관한 중요한 규정을 변경하거나 이용자에게 불리하게 약관의 내용을 변경하는 경우에는 최소한 그 적용일자로부터 30일 전부터 공시합니다. 

④ 본 약관의 적용기간은 이용자의 가입 일부터 해지일까지 입니다. 다만, 잔여 채권ᆞ채무관계가 있는 경우에는 해당 채권·채무의 이행이 완료될 때까지는 그에 필요한 한도 내에서 해지일 이후에도 본 약관 이 적용됩니다. 

⑤ 이용자는 변경된 약관의 내용에 동의하지 않을 권리가 있으며, 변경된 약관의 내용에 동의하지 않을 경우에는 서비스 이용을 중단하고 탈퇴할 수 있습니다. 다만, 이용자가 제3항의 방법 등으로 고지한 바에 따라 변경된 약관의 적용 전일까지 별도의 의사를 표시하지 않은 경우에는 변경된 약관에 동의한 것으로 간주합니다. 

⑥ 서비스제공업체와 이용자는 필요에 따라 별도의 계약(서면 합의)을 체결할 수 있으며 해당 내용이 본 약 관과 상충하는 경우에는 별도의 계약 서면에 명시된 내용이 우선하여 적용됩니다.


제4조 (약관의 해석 및 그 외 준칙) ① 서비스제공업체는 본 약관 외에 별도의 세부 이용지침을 둘 수 있습 니다. 

② 본 약관에 명시되지 않은 사항에 대해서는 「전기통신기본법」, 「전기통신사업법」, 「전자상거래 등에 서의 소비자보호에 관한 법률」, 「저작권법」, 「독점규제 및 공정거래에 관한 법률」 등 관계 법령 및 제1 항의 세부 이용지침 등 규정에 의합니다.


제 2 장 서비스 이용 계약


제5조 (이용계약의 체결) ① 이용 계약은 서비스를 이용하고자 하는 자가 본 약관의 내용 및 개인정보처 리방침에 대하여 동의 후 가입 신청을 하고 서비스제공업체가 이를 승낙함으로써 체결됩니다. 

② 서비스제공업체는 가입 신청자의 신청에 대하여 제6조에서 정한 사유가 있는 경우에는 제6조에 따라 승 낙하지 않을 수 있으며, 가입 이후에도 제6조에서 정한 사유가 확인될 경우에는 승낙을 취소하거나 이 용계약을 해지할 수 있습니다.


제6조 (이용승낙의 제한) 
① 서비스제공업체는 가입 신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으 로 합니다. 다만, 서비스제공업체는 다음 각 호에 해당하는 신청에 대하여는 승낙을 제한할 수 있으며 가입 승낙 이후 다음 각 호에 해당하는 사유가 발생하는 경우 이용계약을 해지할 수 있습니다. 

실명이 아니거나 타인의 명의를 이용하여 허위로 신청하는 경우
서비스제공업체가 제시하는 내용을 기재하지 않거나 잘못 기재하여 신청하는 경우
가입 신청자가 본 약관에 의하여 이전에 이용자 자격을 상실한 적이 있는 경우
가입 신청자가 서비스의 정상적인 제공을 저해하거나 다른 이용자의 서비스 이용에 지장을 줄 것으 로 예상되는 경우
악성 프로그램 및 버그 이용 또는 시스템 취약점을 악용하는 등 부정한 방법을 서비스에 사용한 경 우
하나의 ID를 복수의 사업자 또는 개인이 공동으로 사용하는 경우
ID 생성과 관련하여 부정한 행위가 의심되는 경우
기타 서비스제공업체가 정한 이용신청 요건이 충족되지 않을 경우
② 제1항의 사유가 발생하는 경우, 이용자는 서비스제공업체의 가입 승낙 취소 또는 이용계약 해지와 관련 하여 서비스제공업체에게 어떠한 손해배상도 청구할 수 없습니다. 

③ 서비스제공업체는 가입 신청 시 제1항 각 호의 사유가 존재하는지 관리·감독할 수 있습니다. 

④ 서비스제공업체는 가입 신청자의 신청에 대하여 제6조에서 정한 사유가 있는 경우에는 제6조에 따라 승 낙하지 않을 수 있으며, 가입 이후에도 제6조에서 정한 사유가 확인될 경우에는 승낙을 취소하거나 이 용계약을 해지할 수 있습니다. 

기술상 서비스 제공이 불가능하거나 서비스 관련 설비 용량이 부족한 경우
서비스 상의 장애가 발생한 경우
기타 서비스제공업체가 재정적·기술적으로 필요하다고 인정하는 경우
⑤ 서비스제공업체는 가입 신청자의 신청에 대하여 제6조에서 정한 사유가 있는 경우에는 제6조에 따라 승 낙하지 않을 수 있으며, 가입 이후에도 제6조에서 정한 사유가 확인될 경우에는 승낙을 취소하거나 이 용계약을 해지할 수 있습니다.


제7조 (이용계약의 해지 및 이용제한 등) ① 이용자가 이용계약을 해지하고자 하는 때에는 언제든지 정 해진 절차에 따라 이용자의 ID를 삭제하고 탈퇴할 수 있습니다. 

② 이용계약의 해지는 이용자 탈퇴 페이지에서 신청할 수 있습니다. 

③ 이용자가 본 약관 제11조(이용자의 의무)를 준수하지 않은 경우에는 서비스제공업체가 이용계약을 해지할 수 있고, 이 경우 서비스제공업체는 본 약관 제14조에 의하여 이용자에게 손해배상책임을 물을 수 있습니다. 

④ 서비스제공업체는 제1항 또는 제3항에 의하여 이용계약을 해지하는 경우 그 사실을 이용자에게 사전에 통지합니다. 다만 사전 통지가 어려운 부득이한 사정이 있는 경우 해지 이후 통지할 수 있습니다. 

⑤ 이용자가 연속하여 365일 동안 서비스에 로그인한 기록이 없는 경우 서비스제공업체는 이용자의 개인정보를 보호하기 위해 이용자의 계정을 휴면계정 이용자로 전환하고 개인정보 별도 분리보관 등 필요한 조치를 할 수 있습니다. 이 경우 서비스제공업체는 이용자가 휴면계정으로 전환되기 30일 전 개인정보가 분리보관 된다는 사실을 통지합니다. 서비스제공업체는 이용자가 통지일로부터 30일 내에 재 접속을 하지 않을 경우 이용자의 개인정보를 분리보관 합니다. (다만, 이용자의 정보가 정확하지 않은 경우 알림 대상에 서 제외될 수 있습니다.) 

⑥ 이용자의 계정이 휴면으로 전환된 후 365일 동안 일반 계정으로 전환한 기록이 없는 경우 서비스제공업체는 이용계약을 해지할 수 있습니다. 다만, 서비스제공업체는 이용계약 해지 30일 전 이 사실을 통지해야 하며 30일 내 일반 계정으로 전환하지 않을 경우 이용계약은 해지됩니다. 

⑦ 서비스제공업체는 이용자가 본 약관 상 의무를 위반한 경우 사전 통지 없이 이용계약을 해지할 수 있습니다. 

⑧ 서비스제공업체가 본 약관상의 방침을 준수하였음에도 발생하는 이용자의 손해는 서비스제공업체가 책임지지 않으며, 이용자가 직접 책임을 부담함을 원칙으로 합니다. 

⑨ 이용자가 다음 각 호의 사유에 해당하거나 본 약관상의 의무를 이행하지 않은 경우, 서비스제공업체는 이용자의 자격을 제한 또는 정지시킬 수 있으며, 이용자는 서비스제공업체에게 이로 인하여 발생한 손해에 대하여 보상을 청구할 수 없습니다. 

「전기통신기본법」, 「전기통신사업법」, 「정보통신에 관한 심의규정」, 「컴퓨터프로그램 보호법」 및 기타 관련 법령 또는 본 약관에 위반되거나 미풍양속에 반하는 행위를 하는 경우
방송통신위원회 또는 한국인터넷진흥원 등 공공기관이 불법 스팸 전송 사실을 확인하여 이용정지를 요청하는 경우
본 약관 제11조에 따른 이용자의 의무 중 하나 이상을 위반하는 경우
⑩ 이용자가 다음 각 호중 어느 하나에 해당하는 행위를 하는 경우에 서비스제공업체는 해당 이용자의 자격을 상실 시킬 수 있으며, 이용자는 서비스제공업체에게 자격 상실에 따른 보상을 청구할 수 없습니다. 

다른 이용자의 아이디(ID), 명의를 도용한 경우
서비스를 해킹하거나 악성프로그램을 배포하는 경우
⑪ 이용자는 본 조에 따른 서비스제공업체의 조치에 대하여 서비스제공업체가 정한 절차에 따라 이의신청을 할 수 있으며, 서비스제공업체는 이용자의 이의가 정당하다고 인정하는 경우 즉시 서비스의 이용을 재개합니다.


제 3 장 서비스 제공 및 이용


제8조 (앱 서비스 제공시간 등) ① 서비스제공업체는 이용자와의 이용계약이 성립된 때부터 서비스를 개시합니다. 다만, 일부 서비스의 경우에는 사전에 지정한 일자부터 서비스를 개시합니다. 

② 서비스제공업체는 업무상 또는 기술상의 장애로 인하여 서비스를 중단하는 경우에는 해당 내용을 서비스제공업체 홈페이지 등에 공시합니다. 

③ 서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 다만, 업무상 또는 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 정기점검 등 운영상의 목적으로 일시 중지될 수 있습니다. 이러한 경우 사전에 이를 공지하되, 사전에 공지하기 어려운 부득이한 사정이 있는 경우 사후에 이를 공지합니다. 

④ 일부 서비스는 특정 이용자에게만 제공할 수도 있습니다. 

⑤ 서비스제공업체는 서비스를 일정범위로 분할하여 각 범위별로 이용가능 시간을 별도로 정할 수 있습니다. 이 경우 서비스제공업체는 그 내용을 사전에 공지합니다.


제9조 (서비스의 변경, 중지 및 정보의 저장과 사용) ① 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, 서비스제공업체의 관리범위 외의 서비스 설비 장애 및 기 타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 또는 기타 통신 데이터의 손실에 대해 서비스제공업체의 책임이 면제됩니다. 

② 서비스제공업체는 정상적인 서비스 제공의 어려움으로 인하여 일시적으로 서비스를 중지하여야 할 경우 서비스 중지 7일 전에 고지 후 서비스를 중단할 수 있으며, 이 기간 동안 이용자가 고지내용을 인지하 지 못한데 대하여 서비스제공업체의 책임이 면제됩니다. 다만, 사전에 고지하기 어려운 특별한 사정이 있을 경우 서비스 중단 이후 지체 없이 고지할 수 있습니다. 

③ 서비스제공업체는 제2항에 따른 서비스 중단에 의하여 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 그에 대한 책임이 면제됩니다. 

④ 서비스제공업체의 사정으로 서비스를 영구적으로 중단하여야 할 경우 제2항 및 제3항을 준용합니다.


제 4 장 계약 당사자의 의무


제10조(서비스제공업체의 의무)
 ① 서비스제공업체는 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 본 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는데 최선을 다하여 야 합니다. 

② 서비스제공업체는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안 시스템을 갖추어야 합니다. 

③ 서비스제공업체는 본 서비스를 통하여 시민 편의 서비스 앱으로 연결되는 링크를 제공하며, 시민 편의 서비스 앱의 이용에 관하여는 해당 앱에서 제공하는 별도의 이용약관이 적용됩니다.


제11조 (이용자의 의무) ① 이용자는 서비스 이용에 필요한 개인정보, 이메일, 결제수단에 관한 정보 등의 관리책임을 부담하며, 서비스의 이용과 관련하여 위 정보를 제3자가 사용하도록 하여서는 안 됩니다. 

② 이용자는 관계 법령, 이 약관의 규정, 서비스 이용안내 등 서비스제공업체가 고지하는 사항을 준수하여야 하며 업무를 방해하거나 저해하는 행위를 하여서는 안됩니다. 

③ 이용자는 다음 각 호의 행위를 하여서는 안 됩니다. 

서비스 신청 또는 변경 시 허위내용의 등록행위
타인의 정보 도용행위
서비스제공업체가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시행위
서비스제공업체 또는 기타 제3자의 저작권 등 지식재산권 침해행위
서비스제공업체 또는 기타 제3자의 명예·신용 훼손 또는 업무방해행위
서비스제공업체의 동의 없이 영리 목적으로 서비스를 사용하는 행위
가공행위를 통하여 서비스를 복제, 분해 또는 모방 기타 변형하는 행위
자동 접속 프로그램(매크로) 등에 의하여 비정상적인 방법으로 서비스를 이용하여 서비스제공업체의 업 무 및 서비스 제공을 방해하는 행위
기타 관계법령이나 본 약관, 서비스 이용안내 등에 위배되는 행위
④ 이용자가 제3항 각 호의 의무를 위반함으로 인하여 서비스제공업체 또는 제3자에게 재산적·비재산적 손 해가 발생한 경우 서비스제공업체는 그로 인하여 발생한 손해로부터 면책되고, 해당 이용자에 대하여 민사 상 손해배상의 청구, 형사 고발, 행정기관에 대한 신고 등 일체의 법적 조치를 취할 수 있습니다. 

⑤ 이용자의 단말기(휴대용단말기 등) 분실, 교체, 서비스의 자체 백업 등으로부터 발생하는 손해에 대하 여는 이용자 본인이 책임을 부담합니다.


제12조 (개인정보 보호) ① 서비스제공업체는 관련 법령이 정하는 바에 따라 이용자의 개인정보를 수집ᆞ이 용하며, 관련 법령에서의 예외를 제외하고 이용자의 동의 없이 제3자에게 개인정보를 제공하지 않습니다. 서비스제공업체는 이용자의 개인정보를 보호하기 위하여 최선의 노력을 다하고 있으며, 이용자의 개인정보 보호에 관한 사항은 관계 법령 및 서비스제공업체의 개인정보처리방침에 따릅니다. 

② 서비스제공업체는 서비스가 제공되는 기간에만 이용자의 개인정보를 보유ᆞ이용하고 이용자가 탈퇴하거 나 서비스제공업체가 개인정보 이용 목적을 달성한 경우 또는 이용자가 일정 기간 서비스를 이용하지 않아 개인정보의 유효기간이 도래하는 경우 개인정보를 파기하며, 개인정보의 유효기간 만료 30일 이내에 해 당 사실을 전자적 방법(SMS, 이메일 등)으로 공지합니다. 개인정보의 유효기간은 이용자가 서비스를 이 용한 최종 로그인 시점으로부터 기산됩니다. 

③ 제2항의 개인정보의 유효기간은 원칙적으로 1년으로 하되, 관련 법령에서 다르게 정하는 경우에는 다음 각 호와 같이 설정합니다. 

표시ᆞ광고에 관한 기록: 6개월
계약 등에 관한 기록: 5년
대금결제 및 재화 등의 공급에 관한 기록: 5년
소비자의 불만 또는 분쟁처리에 관한 기록: 3년
그 외 다른 법령에서 다르게 정하는 경우: 해당 법령에서 정하는 기간
⑤ 서비스제공업체는 이용자의 귀책사유로 인하여 유출된 개인정보에 대해서 일체의 책임을 부담하지 않습 니다.


제13조 (개인정보의 처리 위탁) 
① 서비스제공업체는 수집된 개인정보의 처리 및 관리 등의 업무를 스스로 수 행함을 원칙으로 하나, 다음 각 호의 경우에는 업무의 일부 또는 전부를 서비스제공업체가 선정한 제3자에 게 위탁할 수 있습니다. 이 경우 이용자의 개인정보 처리 등의 위탁에 대해서는 서비스제공업체의 개인정보 처리방침이 적용됩니다. 

서비스 제공을 위해 이용자가 가입한 연계 서비스 제공자에게 제공하는 경우
통계 작성,학술 연구또는시장 조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
기타 법률의 규정에 따라 제공하는 경우 

제 5 장 손해배상 등


제14조 (손해배상) ① 이용자가 본 약관을 위반하거나 위법한 행위를 함으로 인하여 발생하는 모든 문 제에 대하여는 이용자에게 책임이 있습니다. 이용자는 이로 인하여 발생한 서비스제공업체 또는 제3자의 손 해에 대하여 그 전액을 배상하여야 합니다. 

② 이용자가 제1항의 행위를 함으로 인하여 서비스제공업체가 제3자로부터 손해배상 청구 또는 소송을 비롯 한 각종 이의제기를 받는 경우 당해 이용자는 자신의 책임과 비용으로 서비스제공업체를  면책시켜야 하며, 서비스제공업체가 면책되지 못한 경우 당해 이용자는 그로 인하여 서비스제공업체에게 발생한 모든 손해를 배상 하여야 합니다.


제15조 (면책조항) ① 서비스제공업체는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제됩니다. 

② 서비스제공업체는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다. 

③ 서비스제공업체는 이용자가 서비스를 통하여 기대하는 이익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다. 

④ 서비스제공업체는 이용자가 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다. 

⑤ 서비스제공업체는 이용자가 본 약관 제10조 제3항의 특구 서비스 앱 및 제10조 제6항의 시민 편의 서비스 앱 등에서 제공되는 서비스를 이용하는 과정에서 발생한 손해에 대하여 어떠한 책임도 부담하지 않습니다.


제16조 (관할법원) ① 서비스 이용과 관련하여 분쟁이 발생한 경우, 서비스제공업체와 이용자는 분쟁을 원만 하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다. 

② 제1항의 규정에도 불구하고 서비스 이용 과정에서 발생한 분쟁에 대하여 소송이 제기될 경우 부산광역시의 관할 법원을 관할법원으로 합니다. 

본 서비스이용약관 2024년 10월 7일부터 적용됩니다.
`,
};
